import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    category: [],
    menus: [],
    menulist1:[],
    menulist2: [],
    menulist3: [],
    menudefs: [],
    original: [],
    menucolors: [],
    recievemsg: [],
    sendmsg: [],
    washmark: [],
    washlist1:[],
    washlist2: [],
    washlist3: [],
    washlist4: [],
    washlist5: [],
    washlist6: [],
    washlist7: [],
    washnone: '0',
    categoryops: {},    // 操作区分一覧{menu_cat_category:menu_cat_operation}
    selectedcategory: "My MENU",
    selectedoperation: 0,  // 現在選択中の操作区分
    dashboard: false,
};

function MenuFilter(menus, index, category) {
    const menulist = menus.filter(function (menu) {
        return (menu.category === category && menu.column === index);
    })
    menulist.sort(function (a, b) {
        if (a.index < b.index) return -1;
        if (a.index > b.index) return 1;
        return 0;
    });
    return menulist;
}

function buildCaetgoryOps(category) {
    const ops = {};
    if (!Array.isArray(category)) return ops;
    for (let i = 0; i < category.length; i++) {
        const row = category[i];
        if (!Array.isArray(row) || row.length === 0) continue;
        const key = row[0];
        const op = Number(row[4] ?? 0); //操作区分は[4]の位置
        ops[key] = Number.isNaN(op) ? 0 : op;
    }
    return ops;
}

function setWashlist(washmark, list1,list2,list3,list4,list5,list6,list7) {
    if (washmark.length === 0) return '0';
    var washnone = "0";
    for (let i = 0; i < washmark.length; i++) {
        let values = washmark[i];
        let key = values[0];
        if (key === "0") {
            washnone = values[1];
        }
        if (key >= 100 && key < 200) {
            list1.push({ key:key, value:values[1] });
        }
        if (key >= 200 && key < 300) {
            list2.push({ key: key, value: values[1] });
        }
        if (key >= 300 && key < 400) {
            list3.push({ key: key, value: values[1] });
        }
        if (key >= 400 && key < 500) {
            list4.push({ key: key, value: values[1] });
        }
        if (key >= 500 && key < 600) {
            list5.push({ key: key, value: values[1] });
        }
        if (key >= 600 && key < 700) {
            list6.push({ key: key, value: values[1] });
        }
        if (key >= 700 && key < 800) {
            list7.push({ key: key, value: values[1] });
        }
    }
    return washnone;
}
const menuSlice = createSlice({
    name: 'menu',
    initialState,
    reducers: {
        setmenus: (state, action) => {
            var list1 = [];
            var list2 = [];
            var list3 = [];
            var list4 = [];
            var list5 = [];
            var list6 = [];
            var list7 = [];
            const categoryops = buildCaetgoryOps(action.payload.categosy);
            const selectedoperation = categoryops[state.selectedcategory] ?? 0; //
            let washnone = setWashlist(action.payload.washmark, list1,list2,list3,list4,list5,list6,list7);
            return Object.assign({}, state, {
                category: action.payload.category, menus: action.payload.menus,
                menulist1: MenuFilter(action.payload.menus, 0, state.selectedcategory),
                menulist2: MenuFilter(action.payload.menus, 1, state.selectedcategory),
                menulist3: MenuFilter(action.payload.menus, 2, state.selectedcategory),
                menudefs: action.payload.menudefs,
                original: action.payload.original,
                menucolors: action.payload.menucolors,
                recievemsg: action.payload.recievemsg,
                sendmsg: action.payload.sendmsg,
                washmark: action.payload.washmark,
                washlist1:list1,
                washlist2: list2,
                washlist3: list3,
                washlist4: list4,
                washlist5: list5,
                washlist6: list6,
                washlist7: list7,
                washnone: washnone,
                categoryops: categoryops,
                selectedoperation: selectedoperation,
                dashboard: action.payload.dashboard,
            })
        },
        setselectedcategory: (state, action) => {
            return Object.assign({}, state, {
                selectedcategory: action.payload,
                menulist1: MenuFilter(state.menus, 0, action.payload),
                menulist2: MenuFilter(state.menus, 1, action.payload),
                menulist3: MenuFilter(state.menus, 2, action.payload)
            })
        },
        enterlist: (state, action) => {
            return Object.assign({}, state, {
                menulist1: MenuFilter(state.menus, 0, action.payload),
                menulist2: MenuFilter(state.menus, 1, action.payload),
                menulist3: MenuFilter(state.menus, 2, action.payload)
            })
        },
        menuassign: (state, action) => {
            return Object.assign({}, state, {
                menus: action.payload,
                menulist1: MenuFilter(action.payload, 0, state.selectedcategory),
                menulist2: MenuFilter(action.payload, 1, state.selectedcategory),
                menulist3: MenuFilter(action.payload, 2, state.selectedcategory)
            })
        },
        setrecievemessage: (state, action) => {
            return Object.assign({}, state, {
                recievemsg: action.payload,
            })
        },
        setsendmessage: (state, action) => {
            return Object.assign({}, state, {
                sendmsg: action.payload,
            })
        },
        resetstore: (state, action) => {
            return initialState;
        }
   },
});

export const {
    setmenus, setselectedcategory, enterlist, resetstore, menuassign, setrecievemessage, setsendmessage
} = menuSlice.actions

export default menuSlice;
